var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNegativeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "negative-icon copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Preset",
    transform: "translate(-63.000000, -158.000000)",
    fillRule: "nonzero",
    fill: "#F15B68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(63.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "negative-icon-copy",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17072851,10.988138 C3.74717647,10.988138 1.77593213,9.01689367 1.77593213,6.59334163 C1.77593213,4.16978959 3.74717647,2.19854525 6.17072851,2.19854525 C8.59428054,2.19854525 10.5655249,4.16978959 10.5655249,6.59334163 C10.5655249,9.01689367 8.59428054,10.988138 6.17072851,10.988138 M6.17072851,1.01076244 C3.09247059,1.01076244 0.588149321,3.51508371 0.588149321,6.59334163 C0.588149321,9.67159955 3.09247059,12.1759208 6.17072851,12.1759208 C9.24898643,12.1759208 11.7533077,9.67159955 11.7533077,6.59334163 C11.7533077,3.51508371 9.24898643,1.01076244 6.17072851,1.01076244",
    id: "Fill-74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32570132,7.18482594 C3.02304951,7.15761316 2.7856032,6.90303813 2.7856032,6.59334163 C2.7856032,6.26551357 3.05166655,5.99945023 3.3794946,5.99945023 L5.63628193,5.99945023 L5.63628193,5.99855024 L6.82406474,5.99855024 L6.82406474,5.99945023 L9.08085207,5.99945023 C9.40868012,5.99945023 9.67474347,6.26551357 9.67474347,6.59334163 C9.67474347,6.90303813 9.43729717,7.15761316 9.13464536,7.18482594 L3.32570132,7.18482594 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeIcon);
export default __webpack_public_path__ + "static/media/negative-icon.d993f0764af2e619929ac421c250ec71.svg";
export { ForwardRef as ReactComponent };